import { Controller } from "@hotwired/stimulus";
import { createMap, fitBounds } from "../../helpers/map_helpers.js";

// Connects to data-controller="organizations--farms-map"
// Plots every farm's lot polygons, colored per farm so farms are easy to tell
// apart. Reuses the shared Leaflet map helpers (Mapbox satellite tiles +
// fitBounds) used by the dashboard map.
export default class extends Controller {
  static targets = ["container"];

  static values = {
    lots: Array,
  };

  connect() {
    if (typeof L === "undefined") {
      console.error("Leaflet is not loaded");
      return;
    }

    setTimeout(() => {
      this.initializeMap();
      this.renderLots();
    }, 100);
  }

  disconnect() {
    if (this.map) {
      this.map.remove();
      this.map = null;
    }
  }

  initializeMap() {
    if (!this.hasContainerTarget) return;

    this.map = createMap(this.containerTarget, { lat: 0, lon: 0, zoom: 5 });
  }

  renderLots() {
    if (!this.map || this.lotsValue.length === 0) return;

    const layers = this.lotsValue
      .map((lot) => {
        if (!lot.polygon) return null;

        const layer = L.geoJSON(JSON.parse(lot.polygon)).addTo(this.map);
        layer.setStyle({
          fillColor: lot.color,
          fillOpacity: 0.5,
          color: lot.color,
          weight: 2,
        });
        layer.bindTooltip(this.buildTooltip(lot));
        layer.bindPopup(this.buildPopup(lot));
        layer.on("click", () => layer.openPopup());
        return layer;
      })
      .filter((layer) => layer !== null);

    fitBounds(this.map, layers, { padding: [40, 40] });
  }

  buildTooltip(lot) {
    const tooltip = document.createElement("span");
    tooltip.textContent = `${lot.farm_name} — ${lot.name}`;
    return tooltip;
  }

  buildPopup(lot) {
    const content = document.createElement("div");
    content.className = "p-1";

    const title = document.createElement("h4");
    title.className = "font-semibold mb-1";
    title.textContent = lot.name;
    content.appendChild(title);

    const farmName = document.createElement("p");
    farmName.className = "text-sm text-base-content/70 mb-1";
    farmName.textContent = lot.farm_name;
    content.appendChild(farmName);

    if (lot.url) {
      const link = document.createElement("a");
      link.href = lot.url;
      link.target = "_blank";
      link.rel = "noopener";
      link.className = "text-sm link link-primary";
      link.textContent = lot.link_label;
      content.appendChild(link);
    }

    return content;
  }
}
